export default "__VITE_ASSET__CQhAVAIR__"